module.exports = __webpack_public_path__ + "static/media/blockchain.9c654e63.jpg";